import { diff } from '@dp-vue/utils';

import { isObject } from '../utils';

export const FIELD_TYPE_STRING = 'string';
export const FIELD_TYPE_NUMBER = 'number';
export const FIELD_TYPE_ARRAY = 'array';
export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_BOOLEAN = 'boolean';
export const FIELD_TYPE_OBJECT = 'object';

// eslint-disable-next-line import/prefer-default-export
export function validateRequiredFieldsInObject(obj, requiredFields, validFields) {
  const nonEmptyObject = Object.keys(obj).length !== 0;
  const hasAllRequiredKeys = diff(requiredFields, Object.keys(obj)).length === 0;
  const hasValidValues = !Object.values(obj).some((value) => (typeof value === 'undefined' || value === ''));
  const hasValidFields = () => {
    const fieldsToCompare = [];

    if (isObject(obj)) {
      Object.values(obj).forEach((value) => fieldsToCompare.push(value));

      return diff(fieldsToCompare, validFields).length === 0;
    }

    return validFields.includes(obj);
  };

  return (hasAllRequiredKeys && hasValidValues) || (!nonEmptyObject && hasValidValues) || hasValidFields();
}

export function validateFields(input, { required = [], optional = [] }) {
  const requiredFieldsValid = Object
    .entries(required)
    .every(([field, types]) => validateFieldTypes(input[field], types, field));

  if (!requiredFieldsValid) {
    return false;
  }

  const optionalFieldsValid = Object
    .entries(optional)
    .every(([field, types]) => {
      const value = input[field];

      if (typeof value === 'undefined') {
        return true;
      }

      if (value === null) {
        return true;
      }

      if (validateFieldTypes(value, types, field)) {
        return true;
      }

      return false;
    });

  if (!optionalFieldsValid) {
    return false;
  }

  return true;
}

function validateFieldTypes(value, types, field) {
  return parseTypes(types)
    .some((type) => validateFieldType(value, type, field));
}

function parseTypes(types) {
  if (Array.isArray(types)) {
    return types;
  }

  return types.split('|');
}

function validateFieldType(value, type, field) {
  if (type === FIELD_TYPE_STRING) {
    return typeof value === 'string';
  }

  if (type === FIELD_TYPE_NUMBER) {
    return typeof value === 'number';
  }

  if (type === FIELD_TYPE_BOOLEAN) {
    return typeof value === 'boolean';
  }

  if (type === FIELD_TYPE_OBJECT) {
    return typeof value === 'object';
  }

  if (type === FIELD_TYPE_ARRAY) {
    return Array.isArray(value);
  }

  if (type === FIELD_TYPE_DATE) {
    return value instanceof Date;
  }

  throw new Error(`Unsupported type "${type}" given for value "${field}" in DpCard.`);
}
